<template>
  <Transition :mode="mode" :name="name">
    <slot/>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { mode = "out-in", isVertical = false } = defineProps<{
  readonly mode?: "out-in" | "in-out";
  readonly isVertical?: boolean;
}>();

const name = computed(() => isVertical ? "slide-vertical" : "slide-horizontal");
</script>